import React from 'react'

function DefaultDashboard() {
  return (
    <div>DefaultDashboard</div>
  )
}

export default DefaultDashboard